import React from 'react';

import { skillSet } from '../constants/skillSet';

const Skills = () => (
  <section className="mb-[40px] md:mb-[100px] mt-[100px]" id="skills">
    <div className="wrapper">
      <div className="section-title pb-[60px] dark:before:bg-primaryOrange/25">
        <h2 className="relative text-[32px] md:text-[40px] font-extrabold md:font-bold text-primaryBlack dark:text-white">
          My Skills
        </h2>
      </div>
      <div className="flex gap-6 md:gap-11 mx-auto flex-wrap justify-center">
        {skillSet.map((skill, index) => (
          <div
            key={index}
            className="relative group p-7 rounded-[50%] bg-lightGray hover:bg-white  dark:bg-black3 cursor-pointer
             hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.1)] dark:hover:bg-black3/80 transition duration-300 mb-5 md:mb-0"
          >
            <img
              src={skill.path}
              className="w-[30px] md:w-[40px] grayscale group-hover:grayscale-0 group-hover:scale-125 group-hover:rotate-12
            transition duration-300"
            />
            <p
              className="text-sm md:text-base absolute opacity-0 group-hover:opacity-100 bottom-[-28px] text-primaryBlue grayscale font-semibold
              left-0 right-0 text-center transition duration-500 dark:group-hover:text-white"
            >
              {skill.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
